import React from "react";
import { useParams, useNavigate } from "react-router-dom";
import GlobalBreadcrumbs from "../../components/global/GlobalBreadcrumbs";
import WrapperSection from "../../components/global/WrapperSection";
import FormAddEditSlider from "../../components/sliders/FormAddEditSlider";
import { useGetSlider } from "../../hooks/sliders/useGetSlider";
import LoadingPage from "../../components/global/LoadingPage";

const EditSlider = () => {
    const { id } = useParams();
    const navigate = useNavigate();

    const { isLoading, error, data } = useGetSlider(id);
    const slider = data?.data;

    if (isLoading) return <LoadingPage />;
    if (error) return null;

    const handleSuccess = () => {
        navigate("/sliders");
    };

    return (
        <WrapperSection>
            <GlobalBreadcrumbs />
            <FormAddEditSlider
                isEdit={true}
                currentData={slider}
                onSubmitSuccess={handleSuccess}
            />
        </WrapperSection>
    );
};

export default EditSlider;